import { defineStore } from 'pinia';
import apiClient from '@/util/apiClient';

export const useLearningCenterStore = defineStore('learningCenterStore', {
	state: () => ({
		myLicenses: [],
		userLicensesByUserId: {}
	}),
	actions: {
		/**
		 * pulls the logged-in users licenses
		 * ROUTE: AUTHENTICATED
		 * @returns {Promise<*>}
		 */
		async fetchMyLicenses() {
			const { data } = await apiClient.get('/ussoccer/licenses/me');
			this.myLicenses = Array.isArray(data) ? data : [];
			return this.myLicenses;
		},
		async fetchLicenses(userId) {
			const { data } = await apiClient.get(`/ussoccer/licenses/${userId}`);
			this.licenses = Array.isArray(data) ? data : [];
			return this.licenses;
		},
		async syncLicensesByUssfId(userNumber, ussfId) {
			const { data } = await apiClient.post(`/ussoccer/search/users/${userNumber}/ussf-id`, {
				ussfId: ussfId
			});
			this.licenses = Array.isArray(data) ? data : [];
			return this.licenses;
		},
		/**
		 * for the assignor to pull licenses of officials
		 * ROUTE: ASSIGNOR
		 * @param userId
		 * @returns {Promise<void>}
		 */
		async verifyUser(userId, force = false) {
			if (!force && this.userLicensesByUserId[userId]) {
				return this.userLicensesByUserId[userId];
			}
			const { data } = await apiClient.post(`/ussoccer/verify/${userId}`);
			const licenses = Array.isArray(data.licenses) ? data.licenses : [];
			this.userLicensesByUserId[userId] = licenses;
			return licenses;
		}
	}
});
